<template>
  <v-card class="secondary primary-shadow">
    <v-card-text>
      <v-list color="transparent">
        <v-list-item-group mandatory>
          <v-list-item v-for="item in filteredMenuItems" :key="item.value" v-on:click="SET_SELECTED_MENU(item.value)">
            <v-list-item-icon
              ><v-icon color="primary">{{ item.icon }}</v-icon></v-list-item-icon
            >
            <v-list-item-content>
              <v-list-item-title class="primary--text"> {{ item.title }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import { PERFILES, FEATURES } from '@/perfiles.js'
import { MENU_EXPEDIENTE_PERSONAL } from '@/menuExpedientePersonal.js'

export default {
  props: {
    estatus: {
      type: Number,
    },
  },
  data() {
    return {
      PERFILES,
      FEATURES,
      MENU_EXPEDIENTE_PERSONAL,
      menuItems: [
        { title: 'Datos generales', value: MENU_EXPEDIENTE_PERSONAL.DATOS_GENERALES, icon: 'mdi-account' },
        { title: 'Referencias', value: MENU_EXPEDIENTE_PERSONAL.REFERENCIAS, icon: 'mdi-account-multiple' },
        { title: 'Documentos', value: MENU_EXPEDIENTE_PERSONAL.DOCUMENTOS, icon: 'mdi-folder' },
        {
          title: 'Desarrollo del elemento',
          value: MENU_EXPEDIENTE_PERSONAL.DESARROLLO_ELEMENTO,
          icon: 'mdi-shield-account',
          condition: () => this.estatus < 8 && this.perfil !== PERFILES['Enlace C3'],
        },
        {
          title: 'Trámites administrativos',
          value: MENU_EXPEDIENTE_PERSONAL.TRAMITES_ADMINISTRATIVOS,
          icon: 'mdi-account-alert',
          condition: () => this.estatus < 7,
        },
        {
          title: 'Puesto y dependencia',
          value: MENU_EXPEDIENTE_PERSONAL.PUESTO_DEPENDENCIA,
          icon: 'mdi-domain',
          condition: () => this.estatus < 7,
        },
        {
          title: 'Resultados C3',
          value: MENU_EXPEDIENTE_PERSONAL.RESULTADOS_C3,
          icon: 'mdi-information',
          condition: () =>
            this.estatus < 7 && this.hasAccessToFeature(this.perfil, this.FEATURES.VISUALIZACION_RESULTADOS_C3),
        },
        {
          title: 'Línea del tiempo',
          value: MENU_EXPEDIENTE_PERSONAL.LINEA_TIEMPO,
          icon: 'mdi-chart-timeline-variant',
          condition: () => this.estatus < 7,
        },
        {
          title: 'Media filiación',
          value: MENU_EXPEDIENTE_PERSONAL.MEDIA_FILIACION,
          icon: 'mdi-head-alert',
          condition: () =>
            this.estatus < 7 &&
            this.perfil !== PERFILES['ENLACE_C3_ADMINISTRADOR'] &&
            this.perfil !== PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'] &&
            this.perfil !== PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'] &&
            this.perfil !== PERFILES['ENLACE C3'],
        },
        {
          title: 'Evaluaciones',
          value: MENU_EXPEDIENTE_PERSONAL.EVALUACIONES,
          icon: 'mdi-file-document-edit',
          condition: () => this.perfil == PERFILES['Policia'],
        },
        {
          title: 'Carrera policial',
          value: MENU_EXPEDIENTE_PERSONAL.CARRERA_POLICIAL,
          icon: 'mdi-account-star',
          condition: () =>
            (this.estatus < 7 &&
              this.perfil !== PERFILES['ENLACE_C3_ADMINISTRADOR'] &&
              this.perfil !== PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'] &&
              this.perfil !== PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'] &&
              this.perfil !== PERFILES['ENLACE C3']) ||
            this.perfil === PERFILES['Policia'],
        },
        {
          title: 'Trayectoria laboral',
          value: MENU_EXPEDIENTE_PERSONAL.TRAYECTORIA_LABORAL,
          icon: 'mdi-briefcase',
          condition: () =>
            this.perfil === PERFILES['Enlace C3'] ||
            this.perfil === PERFILES['ENLACE_C3_ADMINISTRADOR'] ||
            this.perfil === PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'] ||
            this.perfil === PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'],
        },
        {
          title: 'LOCs',
          value: MENU_EXPEDIENTE_PERSONAL.LOCS,
          icon: 'mdi-certificate',
          condition: () =>
            this.estatus < 7 &&
            (this.perfil === PERFILES['Administrador IPH+'] || this.perfil === PERFILES['ARMERIA_PERSONAL LOC']),
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    filteredMenuItems() {
      return this.menuItems.filter((item) => !item.condition || item.condition())
    },
  },

  methods: {
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),
  },
}
</script>
